export function handlePasswordManagerInteraction(e: Event) {
  const target = e.target as HTMLElement;
  const is1Password = target.tagName === 'COM-1PASSWORD-BUTTON';

  if (is1Password) {
    e.preventDefault();
  }

  return is1Password;
}
